
export enum AlignType {
    Left = 'Left',
    Center = 'Center',
    Right = 'Right',
}

export enum InputStyleType {
    Default = 'Default',
    Linear = 'Linear',
    Round = 'Round',
    Sharp = 'Sharp'
}

export enum AfterSubmitType {
    Thank,
    Redirect
}